import { useEffect } from 'react';
import { RecoveryProvider, useRecovery } from '@/features/login/forgot';
import { useLocation, useNavigate, Outlet } from 'react-router';
import { RoutePaths } from '@/routing/RoutePaths';

const withRecoveryProvider = WrappedComponent => {
  const Wrapped = ({ ...rest }) => (
    <RecoveryProvider>
      <WrappedComponent {...rest} />
    </RecoveryProvider>
  );

  return Wrapped;
};

export const ForgotLayout = withRecoveryProvider(() => {
  const recovery = useRecovery();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === RoutePaths().login.verify() && !recovery.username) {
      navigate(RoutePaths().login.forgotPassword());
    }
  }, [location.pathname, navigate, recovery.username, recovery.code]);

  return <Outlet />;
});
